import { NavLink, useMatch, useResolvedPath } from 'react-router-dom';

export const CustomNavLink = ({ to, title, icon }: { to: string; title: string; icon: string }) => {
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: false });

  return (
    <NavLink
      to={to}
      className={`flex items-center flex-col text-[--rs-white] focus:text-[--rs-white] hover:text-[--rs-white] ${match ? 'nav-active' : ''}`}>
      <img src={icon} alt={title} />
      <span>{title}</span>
    </NavLink>
  );
};
